import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ba862c30"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["onClick"]
const _hoisted_2 = { class: "welcome-modal" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-square-fill btn-close" }, null, -1))
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "wm-title" }
const _hoisted_6 = { class: "wm-text" }
const _hoisted_7 = { style: {"color":"#9203DD"} }
const _hoisted_8 = { class: "btn-container" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"7px"} }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "373",
    src: "/media/hc/lux_2.png"
  })
], -1))
const _hoisted_10 = {
  class: "w-100 d-flex justify-content-end gap-3 align-items-center",
  style: {"font-family":"'Poppins'","font-size":"12px","color":"#FFFFFF"}
}
const _hoisted_11 = { class: "cursor-pointer d-flex align-items-center gap-2" }

import { computed, onMounted, onUnmounted, ref, watch } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { dashboardService } from "@/modern/services/dashboardService";
import type { ModernUser } from "@/modern/types/dashboard";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const router = useRouter();

const currentLanguage = computed(
  () => store.getters.getCurrentLanguage || localStorage.getItem("currentLanguage") || "en"
);
const user = computed<ModernUser>(() => (store.getters.currentUser ?? {}) as ModernUser);

const show = ref(false);
const dontShowAgain = ref(false);

const closeModal = async () => {
  show.value = false;
  store.commit("setShowWelcomeMessage", false);

  if (dontShowAgain.value) {
    try {
      await dashboardService.markWelcomeAsRead();
    } catch (error) {
      console.error("Error marking welcome modal as read:", error);
    }
  }
};

const onKeydown = (e: KeyboardEvent) => {
  if (e.key === "Escape") {
    void closeModal();
  }
};

const goToCourse = async () => {
  await closeModal();
  await router.push("/training/course/21");
};

onMounted(() => {
  window.addEventListener("keydown", onKeydown);
});

onUnmounted(() => {
  window.removeEventListener("keydown", onKeydown);
});

watch(
  user,
  () => {
    if (!user.value?.is_read_welcome_message && store.getters.getShowWelcomeMessage) {
      show.value = true;
    }else{
      show.value = false;
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_el_checkbox = _resolveComponent("el-checkbox")!

  return (show.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "welcome-overlay",
        onClick: _withModifiers(closeModal, ["self"])
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: "d-flex justify-content-end w-100",
            onClick: closeModal
          }, _hoisted_4),
          _createElementVNode("h2", _hoisted_5, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.page_dashboard.welcome_modal.welcome_message`)), 1),
          _createElementVNode("p", _hoisted_6, [
            _createTextVNode(_toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.page_dashboard.welcome_modal.in_module`)) + " ", 1),
            _createElementVNode("span", _hoisted_7, "\"" + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.page_dashboard.welcome_modal.start_here`)) + "\"", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.page_dashboard.welcome_modal.essential_learning_desc`)), 1)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", {
              class: "btn-wm-start-here",
              onClick: goToCourse
            }, _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.page_dashboard.welcome_modal.start_now`)), 1)
          ]),
          _hoisted_9,
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("label", _hoisted_11, [
              _createVNode(_component_el_checkbox, {
                modelValue: dontShowAgain.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((dontShowAgain).value = $event))
              }, null, 8, ["modelValue"]),
              _createTextVNode(" " + _toDisplayString(_ctx.$t(`${_unref(currentLanguage)}.page_dashboard.welcome_modal.dont_show_again`)), 1)
            ])
          ])
        ])
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})